export default __webpack_public_path__ + "static/media/All_Functional.756fdd7d.gif";